import { FC } from "react";
import AppContainerWrapper from "../components/AppContainerWrapper";

import packageJson from "../../package.json";

const Footer: FC = () => {
  const CREATED_BY = process.env.REACT_APP_CREATED_BY || "";

  return (
    <AppContainerWrapper className="flex flex-col py-4" id="kt_footer">
      <div className="flex flex-col items-center justify-between md:flex-row">
        {/* begin::Copyright */}
        <div className="order-2 text-slate-900 md:order-1">
          <span className="mr-2 font-semibold text-muted">
            {new Date().getFullYear()} &copy;
          </span>
          <a
            href="#"
            className="text-slate-800 no-underline transition-colors hover:text-brand">
            {CREATED_BY}
          </a>
        </div>
        {/* end::Copyright */}
        {/* begin: version */}
        <div className="order-1 text-slate-900">
          <span className="mr-2 font-semibold text-muted">Version:</span>
          <span className="text-slate-800 transition-colors hover:text-brand">
            {packageJson.version}
          </span>
        </div>
        {/* end: version */}
      </div>
    </AppContainerWrapper>
  );
};

export { Footer };
